/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const endPatientAddressWithDate = (
  id: BodyType<string>,
  endPatientAddressWithDateBody: string,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/patient-address/${id}/end`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: endPatientAddressWithDateBody,
    },
    options,
  );
};

export const getEndPatientAddressWithDateMutationOptions = <
  TData = Awaited<ReturnType<typeof endPatientAddressWithDate>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<string> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['endPatientAddressWithDate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endPatientAddressWithDate>>,
    { id: string; data: BodyType<string> }
  > = (props) => {
    const { id, data } = props ?? {};

    return endPatientAddressWithDate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<string> },
    TContext
  >;
};

export type EndPatientAddressWithDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof endPatientAddressWithDate>>
>;
export type EndPatientAddressWithDateMutationBody = BodyType<string>;
export type EndPatientAddressWithDateMutationError = ErrorType<unknown>;

export const useEndPatientAddressWithDate = <
  TData = Awaited<ReturnType<typeof endPatientAddressWithDate>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<string> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<string> }, TContext> => {
  const mutationOptions = getEndPatientAddressWithDateMutationOptions(options);

  return useMutation(mutationOptions);
};
